import React from "react";
import PropTypes from "prop-types";
import agent from "agent";
import { Link } from "react-router-dom";
import StaticWave from "utils/staticWave";
import Download from "components/Common/Download";
import { showTime ,HtmlUtil,addMusicStatis} from "dispatch";
import "./MusicTableCell.less";
import Share from "components/Common/Share";
const jquery = require("jquery");

class MusicTableCell extends React.Component {
    static propTypes = {
        audio: PropTypes.shape({
            id: PropTypes.number.isRequired,
            audioid: PropTypes.string.isRequired,
            thumb: PropTypes.string.isRequired,
            audio: PropTypes.string.isRequired,
            author: PropTypes.numberisRequired,
            title: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
            duration: PropTypes.number.isRequired,
            speed: PropTypes.number.isRequired,
            playing: PropTypes.bool.isRequired,
            merged_peaks: PropTypes.string,
            inverted_condition: PropTypes.object.isRequired,
            // status: "normal",
            // update_at: "2018-12-28T07:45:45.000Z"
        }).isRequired,
        playMusic: PropTypes.func.isRequired,
        addCart: PropTypes.func.isRequired,
        clickFavorite: PropTypes.func.isRequired,
        labels: PropTypes.object.isRequired,
    };

    state = {
        shareVisible: false,
        shareData: { url: "", title: "" },
    };

    handlePlayClick = e => {
        const { audio, playMusic } = this.props;
        const send = {
            ...audio,
            playing: !audio.playing,
        };
        const musicsta = {
            audioid:audio.id,
            style:'play',
        }
        if (!audio.playing) {
            addMusicStatis(musicsta);
        }
        playMusic(send);
    };
    handleCartClick = e => {
        jquery("body").css("overflow","hidden");
        jquery("body").css("height","100%");
        e.preventDefault();
        const { audio, addCart } = this.props;
        const send = {
            ...audio,
        };
        addCart(send);
    };
    handleFavoriteClick = e => {
        const { audio, clickFavorite } = this.props;
        const send = {
            ...audio,
        };
        clickFavorite(send);
    };
    handleShareClick(data) {
        const { audioid, title } = data;
        this.setState({
            shareVisible: true,
            shareData: {
                url: location.origin + "/music/musicid/" + audioid,
                title,
            },
        });
    }

    closeShareModel() {
        this.setState({ shareVisible: false });
    }
    showTags(condition, inverted_condition,speed) {
        let show = "";
        for (let key in inverted_condition) {
            let value = (inverted_condition[key] + "").split(",");
            for (let i = 0; i < condition[key].length; i++) {
                const element = condition[key][i];
                for (let k = 0; k < value.length; k++) {
                    const val = value[k];
                    if (element.id == val) {
                        show += element.title + " / ";
                    }
                }
            }
        }
        if(speed){
            for(let i = 0;i<condition.speed.length;i++){
                if(speed == condition.speed[i].id){
                    const element = condition.speed[i].title;
                    show += element+ " / ";
                }
                else{
                    const element ="";
                    show += element; 
                }
            }
        }
        if (!show) {
            return (
                <span>
                    &nbsp;
                    <br /> &nbsp;
                </span>
            );
        }
        return show;
    }
    render() {
        const {
            id,
            audioid,
            thumb,
            creatorInfo,
            composer,
            title,
            duration,
            speed,
            playing,
            like,
            inverted_condition,
            likeUpdate,
            minprice,
            api_id,
            author,
        } = this.props.audio;
        const labels = this.props.labels;
        const playClass = "playBtn " + (playing ? "is-play" : "is-pause");
        const urls="url("+agent.getApiUrl(thumb)+")";
        const pre="99";
        const vImg=author.userid == 'IVKPCCUGYVS317TCF32BC7BE385C027F'||author.userid == 'WCIRSZ7MUOMGZ4RUE1A728276B7BD15B'||author.userid == 'XBNTVMZD2KVJ5FRK81027164D4516A4C'?true:false;
        return (
            <div
                className="resultItem musicItem v_position"
                audioid={audioid}
                id={`music-table-cell-${id}`}
            >
                <Share
                    url={this.state.shareData.url}
                    title={this.state.shareData.title}
                    visible={this.state.shareVisible}
                    onClose={this.closeShareModel.bind(this)}
                />
                <div className="musicItem__jacket" style={{backgroundImage: urls}}>
                </div>
                {vImg?<div className="v_img_style"> <img className="v_style" src="/assets/img/sub_v.png"/></div>:""}
                <div className="musicItem__txtBox">
                    <div className="musicItem__header">
                        <p className="musicItem__playBtn">
                            <button
                                className={playClass}
                                onClick={this.handlePlayClick.bind(this)}
                            >
                                <svg viewBox="0 0 35 35">
                                    <g className="playIcon">
                                        <use xlinkHref="#playIcon" />
                                    </g>
                                    <g className="pauseIcon">
                                        <use xlinkHref="#pauseIcon" />
                                    </g>
                                </svg>
                            </button>
                        </p>
                        <div className="musicItem__header__inner">
                            <p className="musicItem__title" title={HtmlUtil.htmlDecode(title)}>
                                <Link to={`/music/musicid/${audioid}`}>
                                    {HtmlUtil.htmlDecode(title)}
                                </Link>
                                {vImg?<img className="phone_v_style" src="/assets/img/sub_v.png"/>:""}
                            </p>
                            <p className="musicItem__name">
                                {!(creatorInfo&&creatorInfo.status=='normal') ? <span>  by {HtmlUtil.htmlDecode(creatorInfo? creatorInfo.nickname:composer)}</span>:<Link to={`/makerdetail?id=${creatorInfo.id}`}>
                                    by {HtmlUtil.htmlDecode(creatorInfo.nickname)}
                                </Link>}
                            </p>
                        </div>
                        <div className="audio_price">
                            ¥{!api_id?minprice:pre}
                        </div>
                    </div>
                    <div className="musicItem__wave">
                        <StaticWave key={`cell-${audioid}`} {...this.props} />
                        <p className="musicItem__wave__time">
                            {showTime(duration)}
                        </p>
                    </div>

                    <div className="musicItem__utility">
                        <p className="musicItem__utility__category">
                            {/* 显示查出来的标签 */}
                            {this.showTags(labels, inverted_condition,speed)}
                        </p>
                        <ul className="musicItem__utility__items">
                            <li className="musicItem__utility__item musicItem__utility__fav">
                                <button
                                    className={`favBtn ` + (like && `is-fav`)}
                                    onClick={this.handleFavoriteClick.bind(
                                        this
                                    )}
                                    disabled={likeUpdate}
                                >
                                    <svg viewBox="0 0 35 35">
                                        <g className="favIconIn">
                                            <use xlinkHref="#favIconIn" />
                                        </g>
                                        <g className="favIcon">
                                            <use xlinkHref="#favIcon" />
                                        </g>
                                    </svg>
                                </button>
                            </li>
                            <li className="musicItem__utility__item musicItem__utility__share">
                                <a
                                    href="javascript:;"
                                    onClick={this.handleShareClick.bind(this, {
                                        title,
                                        audioid,
                                    })}
                                >
                                    <span>分享</span>
                                </a>
                            </li>
                            <li className="musicItem__utility__item musicItem__utility__cart" id="add_cart">
                                <Link
                                    to="javascript:void(0)"
                                    onClick={this.handleCartClick.bind(this)}
                                />
                            </li>
                            <li className="musicItem__utility__item musicItem__utility__download">
                                <Download audioid={audioid} />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default MusicTableCell;
